import axios from 'axios'

export default async (route, formData) => {
    try {
        let response = await axios.post(route, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return response
    } catch (error) {
        return error
    }
}
